import React from 'react';
import {secretApi} from "../../../api/api";
import {keepPreviousData, useQuery, useQueryClient} from "@tanstack/react-query";
import {useSelector} from "react-redux";

const UseGetChampionBuild = ({champion_id}) => {
    const queryClient = useQueryClient();
    const version = useSelector((state) => state.champions.championVersions);
    const getBuildData = (data) => {
        const url = `${process.env.REACT_APP_CACHE_API}champion/build?platform_id=KR&champion_id=${data.champion_id}&game_version=${data.game_version}&tier=${encodeURIComponent(data.tier)}`;
        return secretApi.get(url).then((result) => {
            const data = result.data;
            const reduced = Object.entries(data.build_by_lane).reduce((sum, cur) => {
                sum.push({...cur[1], lane: cur[0]})
                return sum;
            }, []);
            return reduced
        });
        // return testApi;
    }

    const getVersions = () => {
        const url = `${process.env.REACT_APP_CACHE_API}champion/version?cnt=3`;
        return secretApi.get(url).then((result) => result.data.game_version_list);
    }


    const query = useQuery({
        staleTime:Infinity,
        queryKey: ['llmBuild', champion_id],
        queryFn: async () => {
            if (!champion_id) {
                return null
            }

            const currentVersion = version[0];

            const buildData = await getBuildData({champion_id, game_version: currentVersion, tier: 'Emerald+'})

            return buildData
        },
        placeholderData:keepPreviousData
    })


    return query

};

export default UseGetChampionBuild;